import { StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons"
import * as Fonts from "../../../styles/typography"
import * as Colors from "../../../styles/colors"

export default function BillItem({ iconName, value, highlith = false }) {
    return <View style={styles.viewItem}>
        <Icon size={32} name={iconName}/>
        <Text style={!highlith ? styles.valueText : styles.highLithText}>{`${value}`}</Text>
    </View>
}

const styles = StyleSheet.create({
    valueText: {
        fontSize: Fonts.FONT_SIZE_20,
        fontWeight: "300",
        color: Colors.BLACK,
        marginLeft: 4,
    },
    highLithText: {
        fontSize: Fonts.FONT_SIZE_20,
        fontWeight: "500",
        color: Colors.ALERT,
        marginLeft: 4,
    },
    viewItem: {
        flexDirection: "row",
        alignItems: "center"
    }
})